import { View, StyleSheet } from "react-native";
import React from "react";
import Text from '../../common/component/CustomTextComponent';
import moment from 'moment';
import { THEME_COLORS } from "../themes";
import { toCamelCase } from "@src/utils/functions";

interface ICarDetailInlineProps {
    fontSize?:"medium" | "small" | "x-small" | "large" | "x-large";
    fontWeight?:"one_six" | "two_six" | "three_six" | "four_six" | "five_six" | "six_six";
    carObject: {
        month:string;
        chassisNo:string;
        procCategory:string;
        make: string;
        model: string;
        variant: string;
        registrationNo: string;
        year: string;
        fuelType: string;
        transmission: string;
    };
}
export const CarDetailInline = (props: ICarDetailInlineProps) => {
    
    const { carObject, fontSize, fontWeight } = props;

    const newFontSize = !!fontSize ? fontSize : "medium";
    const newFontWeight = !!fontWeight ? fontWeight : "three_six";

    const shortMonthName = !!carObject && carObject?.month ? moment.monthsShort(parseInt(carObject.month,10) - 1) : ""; 

    return <View style={{flexDirection: "row", flexWrap: 'wrap', flex: 1}}>
        <View style={{flexDirection: "row"}}>
        <Text fontSize={newFontSize} style={{marginLeft: 8,}} type_of_six={newFontWeight} >{shortMonthName}</Text>
            <Text fontSize={newFontSize} style={{marginLeft: 8,}} type_of_six={newFontWeight} >{!!carObject?.year ? carObject.year : ""}</Text>
            <Text fontSize={newFontSize} type_of_six={newFontWeight} style={{marginLeft: 8,maxWidth:150}}>{!!carObject?.make ? carObject.make : ""}</Text>
        </View>
        <View style={{flexDirection: "row"}}>
            <Text type_of_six={newFontWeight} style={{marginLeft: 8}} fontSize={newFontSize}>{!!carObject?.model ? carObject.model : ""}</Text>
            <Text type_of_six={newFontWeight} fontSize={newFontSize} style={{marginLeft: 8,}}>{!!carObject?.variant ? carObject.variant : ""}</Text>
        </View>
        <View style={{flexDirection: "row"}}>
            {!!carObject?.registrationNo && <View style={{flexDirection:"row",marginLeft:8}}><Text type_of_six={newFontWeight} style={{maxWidth: 150}} fontSize={newFontSize}>{carObject?.registrationNo ? carObject?.registrationNo?.toUpperCase() : ""}</Text><View style={styles.divider}/> </View>}
            {!!carObject?.procCategory && <View style={{flexDirection:"row"}}><Text type_of_six={newFontWeight} style={{maxWidth: 150}} fontSize={newFontSize}>{carObject?.procCategory ? carObject?.procCategory?.toUpperCase() : ""}</Text></View>}
            {!!carObject?.chassisNo &&<View style={{flexDirection:"row"}}><View style={styles.divider}/><Text type_of_six={newFontWeight} style={{maxWidth: 300}} fontSize={newFontSize}>C. No: {carObject?.chassisNo}</Text></View>}
            {!!carObject?.fuelType &&<View style={{flexDirection:"row"}}><View style={styles.divider}/><Text type_of_six={newFontWeight} style={{maxWidth: 300}} fontSize={newFontSize}>{toCamelCase?.(carObject?.fuelType)}</Text></View>}
            {!!carObject?.transmission &&<View style={{flexDirection:"row"}}><View style={styles.divider}/><Text type_of_six={newFontWeight} style={{maxWidth: 300}} fontSize={newFontSize}>{toCamelCase?.(carObject?.transmission)}</Text></View>}
        </View>
        
    </View>
};

const styles = StyleSheet.create({
    divider:{
        height:30,
        width:1,
        backgroundColor:THEME_COLORS.grey0,
        marginHorizontal:5
    }
})
